<template>
  <data-form :entity="filters" :fields="fields" @change="filtersChanged" :hideButtons="true" />
</template>

<script>
export default {
  name: 'event-statistics-config',
  props: {
    filters: {
      type: Object,
      default: () => ({
        mobileId: '',
        eventTypeId: '',
        count: 10,
        unit: 'days'
      })
    }
  },
  computed: {
    fields () {
      return {
        mobileId: {
          type: 'select',
          options: this.filterOptions('mobiles')(''),
          filter: this.filterOptions('mobiles'),
          placeholder: true
        },
        eventTypeId: {
          type: 'select',
          options: this.filterOptions('event-types', model => ({ label: 'eventType.' + model.name, value: model.id }))(''),
          filter: this.filterOptions('event-types', model => ({ label: 'eventType.' + model.name, value: model.id })),
          placeholder: true
        },
        unit: {
          type: 'select',
          options: [{label: 'days', value: 'days'}, {label: 'hours', value: 'hours'}, {label: 'minutes', value: 'minutes'}]
        },
        count: {
          type: 'number',
          max: 100,
          rules: [{type: 'number', max: 100}]
        }
      }
    }
  },
  methods: {
    filtersChanged (filters) {
      this.$emit('propertiesChanged', { filters })
    },
    filterOptions (model, map = (model => ({ label: model.contact_name, value: model.id }))) {
      return (query) => {
        const models = this.$store.getters[`${model}/data`](this.$store.dispatch)

        return models
          .map(map)
          .reverse()
          .filter(option => option.label.toLowerCase().includes((query || '').toLowerCase()))
          .slice(0, 10)
      }
    }
  },
  create () {
    this.filterOptions('mobiles')('')
    this.filterOptions('event-types')('')
  }
}
</script>


// WEBPACK FOOTER //
// EventStatisticsConfig.vue?7cbff327